import { createContext, useContext } from "react";
import useCitySelection from "../hooks/useCitySelection";

// Wraps useCitySelection in a provider so the dropdown in the header and
// the catalog page (and anything else added later) share one source of
// truth instead of duplicating the localStorage + geo-guess machinery.
const CitySelectionContext = createContext(null);

export function CitySelectionProvider({ children }) {
  const value = useCitySelection();
  return <CitySelectionContext.Provider value={value}>{children}</CitySelectionContext.Provider>;
}

export function useCitySelectionContext() {
  const ctx = useContext(CitySelectionContext);
  if (!ctx) {
    throw new Error("useCitySelectionContext must be used within CitySelectionProvider");
  }
  return ctx;
}
